module.exports = __webpack_public_path__ + "img/R-C.1a03e659.png";